// Stripe payment processing fees
// Standard Stripe fees: 2.9% + $0.30 per transaction
export const STRIPE_PERCENTAGE_FEE = 0.029; // 2.9%
export const STRIPE_FIXED_FEE = 0.30; // $0.30
export const STRIPE_FIXED_FEE_CENTS = 30; // 30 cents (for API calls using cents)

// Calculate Stripe fee for a given amount
export const calculateStripeFee = (amount: number): number => {
  return amount * STRIPE_PERCENTAGE_FEE + STRIPE_FIXED_FEE;
};

// Calculate Stripe fee in cents (for API calls)
export const calculateStripeFeeCents = (amountCents: number): number => {
  return Math.round(amountCents * STRIPE_PERCENTAGE_FEE + STRIPE_FIXED_FEE_CENTS);
};
